<template>
  <div class="inventory_content">
    <span>分类：</span>
    <a-radio-group v-model="active" class="radio_contents" size="small" @change="handleChange">
      <a-radio-button v-for="item in option" :key="item.value" :value="item.value" border>{{item.label}}</a-radio-button>
    </a-radio-group>
    <goodsBatchList v-if="active==='goodsBatchList'" ref="goodsBatchListRef" :is-now-wa-customer.sync="isNowWaCustomer"/>
    <goodsUsableCollect v-if="active==='goodsUsableCollect'" ref="goodsUsableCollectRef"  :is-now-wa-customer.sync="isNowWaCustomer"/>
    <locationBatches v-if="active==='locationBatches'" ref="locationBatchesRef"  :is-now-wa-customer.sync="isNowWaCustomer"/>
  </div>
</template>

<script>
import activeIcon from '@/assets/img/icon_select.png'
import {postTrack} from '@/utils/point'
import {formatData} from '@/utils/util'
import goodsBatchList from './components/batch.vue'
import goodsUsableCollect from './components/availableQuantity.vue'
import locationBatches from './components/locationBatches.vue'

const activeOption={
  goodsUsableCollect:'按可用量',
  goodsBatchList:'按批次',
}
  export default {
    name:"Inventory",
    components:{
      goodsBatchList,
      goodsUsableCollect,
      locationBatches
    },
    props:{
      isNowWaCustomer:{
        type:Boolean,
        default:()=>false
      }
    },
    data(){
      return {
        activeIcon,
        active:'goodsUsableCollect',
      }
    },
    computed:{
      tabOption(){
        return this.isNowWaCustomer?{...activeOption,locationBatches:'按库位批次库存明细'}:activeOption
      },
      option(){
        return formatData(this.tabOption)
      },
    },
    created(){
      this.handleChange()
    },
    methods:{
      handleChange(){
        postTrack(`数据分析-库存管理-库存查询-${this.tabOption[this.active]}`)
        this.$nextTick(()=>{
          this.$refs[`${this.active}Ref`].init()
        })
      },
    }
  }
</script>

<style lang="less" scoped>
.inventory_content{
  background-color: #fff;
  padding: 24px 0 0 24px;
}
.radio_contents{
  .ant-radio-button-wrapper{
    margin-right: 8px;
    border-radius: 4px;
  }
}
</style>
